import { Grid } from "@mui/material";
import { useState } from "react";
import { CadastrarVincularCliente } from "../../../../../clientes/containers/CadastrarVincularCliente";
import { OperacaoCategoriasProdutosContainer } from "../../../../../produtos/containers/OperacaoCategoriasProdutosContainer";
import { CheckoutPaper } from "../../../../components/CheckoutPaper";
import { ClientePaper } from "../../../../components/ClientePaper";
import { MetodoPagamentoSelect } from "../../../../components/MetodoPagamentoSelect";
import { useOperacaoContext } from "../../../../contexts/OperacaoContext";
import { TipoPedido } from "../../../../enum/TipoPedido";
import { CategoriasContainer, Layer, ProdutosPaper } from "./styles";
import { PedidosNaoConcluidosContainer } from "../PedidosNaoConcluidosContainer";
import { useFetchCategorias } from "../../../../../produtos/hooks/useFetchCategorias";
import { useTamanhoTela } from "../../../../../core/hooks/useTamanhoTela";
import { CarrinhoMobilePaper } from "../../styles";
import { ProdutosCarrinhoContainer } from "../../../../../produtos/containers/ProdutosCarrinhoContainer";
import { EmitirNotaFiscalModal } from "../EmitirNotaFiscalModal";
import { IPagamentoPedido } from "../../../../interface/IPagamentoPedido";
import { DividirPagamento } from "../DividirPagamento";
import { BotoesAcoesCheckout } from "../../../../components/BotoesAcoesCheckout";
import { FidelidadeCardsWrapper } from "../../../../components/FidelidadeCardsWrapper";

export const OperacaoRetirada = () => {
    const { modeloTela } = useTamanhoTela();
    const { categorias, isLoading } = useFetchCategorias();
    const {
        cliente,
        vincularCliente,
        adicionarProduto,
        removerCliente,
        valorTotalPedido,
        pagamentos,
        produtos,
        aumentarQuantidade,
        diminuirQuantidade,
        removerProduto,
        fecharPedido,
        loading,
        alterarTipo,
        agendadoPara,
        agendarHorario,
        salvarPedido,
        editarProduto,
        numeroPedidoDiario,
        numeroTotalItens,
        switchNotaFiscal,
        handleSwitchNotaFiscal,
        configuracaoNFCe,
        alterarPagamentos,
        switchImprimirAutomatico,
        handleSwitchImprimirAutomatico,
        fluxoContexto,
        abrirDrawerPagamento,
        cupons,
        abrirDrawerCupons,
        aplicarCupom
    } = useOperacaoContext();

    const [mostrarHorario, setMostrarHorario] = useState(false);

    const handleAlterarPagamento = (pagamento?: IPagamentoPedido) => {
        if (!pagamento?.metodoPagamento) {
            alterarPagamentos(undefined);
        } else {
            alterarPagamentos([pagamento]);
        }
    }


    return (
        <Grid
            container
            spacing={0}
            sx={{ width: "100%", height: "100%" }}
            justifyContent={"center"}
            alignItems={"center"}
        >

            <Grid item xs={12} md={9} lg={9}>
                <ProdutosPaper variant="outlined">
                    <CategoriasContainer>
                        <OperacaoCategoriasProdutosContainer
                            categorias={categorias}
                            adicionarProduto={adicionarProduto}
                            contexto={TipoPedido.retirada}
                            cliente={cliente}
                            fecharPedido={fecharPedido}
                            carrinhoContainer={
                                <ProdutosCarrinhoContainer
                                    categorias={categorias}
                                    produtosCarrinho={produtos}
                                    aumentarQuantidade={aumentarQuantidade}
                                    diminuirQuantidade={diminuirQuantidade}
                                    removerProduto={removerProduto}
                                    editarProduto={editarProduto}
                                />
                            }
                        />
                        {!cliente && (
                            <Layer>
                                <CadastrarVincularCliente vincularCliente={vincularCliente} />
                            </Layer>
                        )}
                    </CategoriasContainer>
                </ProdutosPaper>
            </Grid>
            <Grid item xs={12} md={3} lg={3}>
                <CheckoutPaper
                    loading={loading}
                    valorTotalPedido={valorTotalPedido}
                    numeroTotalItens={numeroTotalItens}
                    numeroPedidoDiario={numeroPedidoDiario}
                    opcoes={[
                        {
                            titulo: "Concluir",
                            funcao: fecharPedido,
                            atalho: "F8"
                        },
                        {
                            titulo: "Salvar",
                            funcao: salvarPedido,
                            atalho: "F9"
                        },
                        {
                            titulo: "Dividir pagamento",
                            funcao: abrirDrawerPagamento
                        }
                    ]}
                >
                    <ClientePaper
                        cliente={cliente}
                        removerCliente={removerCliente}
                    />
                    <FidelidadeCardsWrapper
                        cliente={cliente}
                        cupons={cupons}
                        aplicarCupom={aplicarCupom}
                        adicionarProduto={adicionarProduto}
                        categorias={categorias || []}
                        produtos={produtos}
                    />
                    <MetodoPagamentoSelect
                        pagamento={pagamentos[0]}
                        onChange={handleAlterarPagamento}
                        valorTotal={valorTotalPedido}
                    />
                    <BotoesAcoesCheckout
                        switchImprimirAutomatico={switchImprimirAutomatico}
                        handleSwitchImprimirAutomatico={handleSwitchImprimirAutomatico}
                        switchNotaFiscal={switchNotaFiscal}
                        handleSwitchNotaFiscal={handleSwitchNotaFiscal}
                        configuracaoNFCeObrigatorio={configuracaoNFCe?.obrigatorio}
                        agendadoPara={agendadoPara}
                        agendarHorario={agendarHorario}
                        mostrarHorario={mostrarHorario}
                        toggleHorario={() => setMostrarHorario(!mostrarHorario)}
                        quantidadeCupons={cupons.length}
                        abrirDrawerCupons={abrirDrawerCupons}
                    />
                    {modeloTela == "mobile" && (produtos?.length > 0) && (
                        <CarrinhoMobilePaper variant="outlined" sx={{ marginTop: "1rem" }}>
                            <ProdutosCarrinhoContainer
                                categorias={categorias}
                                produtosCarrinho={produtos}
                                aumentarQuantidade={aumentarQuantidade}
                                diminuirQuantidade={diminuirQuantidade}
                                removerProduto={removerProduto}
                                editarProduto={editarProduto}
                            />
                        </CarrinhoMobilePaper>
                    )}
                </CheckoutPaper>
            </Grid>
        </Grid>
    );
}